module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Bold.94871155.woff";